export const benefits = [
  {
    icon: "💼",
    title: "Bangun Portfolio",
    description: "Kembangkan portfolio profesional dengan proyek nyata"
  },
  {
    icon: "🎯",
    title: "Metode Simulasi",
    description: "Belajar langsung melalui pengalaman simulasi mendalam"
  },
  {
    icon: "👨‍🏫",
    title: "Mentor Berpengalaman",
    description: "Dibimbing oleh praktisi industri berpengalaman"
  },
  {
    icon: "📜",
    title: "Sertifikat Resmi",
    description: "Dapatkan sertifikat yang diakui industri"
  }
];
